import { createStore, applyMiddleware, combineReducers } from 'redux';
import { reducer as formReducer }                        from 'redux-form';
import { composeWithDevTools }                           from '@redux-devtools/extension';
import thunkMiddleware                                   from 'redux-thunk';

export function configureStore(props) {
  const combined = combineReducers({
    form: formReducer,
  });
  const compose  = process.env.NODE_ENV === 'production'
    ? applyMiddleware(thunkMiddleware)
    : composeWithDevTools(applyMiddleware(thunkMiddleware));

  return createStore(
    combined,
    compose,
  );
}